import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './LandingPage';
import HomePage from './HomePage';

// InvoicePage (and @react-pdf/renderer) only loads when the user navigates to /invoice
const InvoicePage = lazy(() => import('./InvoicePage'));

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={
        <div className="min-h-screen bg-stone-50 flex items-center justify-center">
          <span className="section-label text-stone-400">Loading...</span>
        </div>
      }>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/resume" element={<HomePage />} />
          <Route path="/invoice" element={<InvoicePage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
